import { Emotion } from '@/models'

export default class EmotionRepo extends AxiosRepository {
  use = Emotion
}
